import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Star = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Star' {...props}>
    <polygon fill='#FFC95E' fillRule='evenodd' points='12 16.667 5 22 8 14 2 9.5 9.5 9.5 12 2 14.5 9.5 22 9.5 16 14 19 22' />
  </StyledIcon>
);
